import { createPopper } from '@popperjs/core'

const popperContainerEl = document.querySelectorAll('.js_popperContainer')

if (popperContainerEl.length) {
    popperContainerEl.forEach((el) => {
        const popperTooltip = el.querySelector('.js_popperTooltip')

        console.log({ el, popperTooltip })

        if (!popperTooltip) {
            return
        }

        const skiddingOffset = el.getAttribute('data-popper-skidding') ? Number(el.getAttribute('data-popper-skidding')) : 0
        const distanceOffset = el.getAttribute('data-popper-distance') ? Number(el.getAttribute('data-popper-distance')) : 0

        createPopper(el, popperTooltip, {
            placement: el.getAttribute('data-popper-placement') ? el.getAttribute('data-popper-placement') : 'bottom',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [skiddingOffset, distanceOffset]
                    }
                }
            ]
        })
    })
}
